import { TLanguages } from "@/i18nConfig"
import loadLocale from "@/locales/loadLocale"

export function getRandom(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }
  
  export const createArray = (length: number) => [...Array(length)]
  
  export const wait = (number: number) => new Promise((resolve) => setTimeout(resolve, number))
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  export const debounce = <T extends (...args: any[]) => any>(fn: T, ms = 300) => {
    let timeoutId: ReturnType<typeof setTimeout>
    return function (this: ThisParameterType<T>, ...args: Parameters<T>): void {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => fn.apply(this, args), ms)
    }
  }
  
  export const filterObjectValueByArg = <T extends Record<string, any>>(obj: T, ...arg: unknown[]) => {
    const newObj = {} as T
    for (const key in obj) {
      const isObj = !!Object.prototype.hasOwnProperty.call(obj, key)
      if (!isObj) throw new Error('not an object')
      const isSkip = arg.reduce((acc, cur) => acc || obj[key] === cur, false)
      if (!isSkip) newObj[key] = obj[key]
    }
    return newObj
  }

  export const removeUndefinedAndNullAndEmpty = <T extends Record<string, any>>(obj: T) =>
    filterObjectValueByArg(obj, undefined, null, '')
  
  export function catchError<T>(promise: Promise<T>): Promise<[undefined, T] | [Error]> {
    return promise
      .then((data) => {
        return [undefined, data] as [undefined, T]
      })
      .catch((error) => {
        return [error]
      })
  }
  
  export function catchErrorTyped<T, E extends new (message?: string) => Error>(
    promise: Promise<T>,
    errorsToCatch?: E[]
  ): Promise<[undefined, T] | [InstanceType<E>]> {
    return promise
      .then((data) => {
        return [undefined, data] as [undefined, T]
      })
      .catch((error) => {
        if (errorsToCatch == undefined) {
          return [error]
        }
        throw error
      })
  }


  export const createt = async (lang: TLanguages) => {
    const metaData = await loadLocale(lang)
    return (key: string) => metaData?.[key as keyof typeof metaData] || ''
  }
  



  interface Binary<A, B, C> {
    (a: A, b: B): C
  }
  interface Unary<A, B> {
    (a: A): B
  }
  
  export function map<A, B>(fn: Unary<A, B>) {
    return function (list: A[]) {
      const result: B[] = []
      for (const item of list) {
        result.push(fn(item))
      }
      return result
    }
  }
  
  export function flatten<T>(array: Array<T | T[]>): T[] {
    return array.reduce<T[]>((acc, val) => {
      if (Array.isArray(val)) {
        acc.push(...flatten(val))
      } else {
        acc.push(val)
      }
      return acc
    }, [])
  }
  
  export function box<A>(x: A) {
    function pipe<B>(fn: Unary<A, B>) {
      return box(fn(x))
    }
    function unwrap() {
      return x
    }
  
    return { pipe, unwrap }
  }
  
  export function prop<A, K extends keyof A>(key: K) {
    return function (obj: A) {
      return obj[key]
    }
  }
  
  export function reduce<A, B>(fn: Binary<A, B, A>) {
    return function (initial: A) {
      return function (list: B[]) {
        for (const item of list) {
          initial = fn(initial, item)
        }
        return initial
      }
    }
  }
  
  function isNotNull<A>(x: A): x is NonNullable<A> {
    return x != null
  }
  
  export function maybe<A>(x: A) {
    function pipe<B>(fn: Unary<NonNullable<A>, B>) {
      const y = isNotNull(x) ? fn(x) : (x as unknown as undefined)
      return maybe(y)
    }
    function unwrap() {
      return x
    }
    return { pipe, unwrap }
  }
  export const applyTo =
    <A, B>(x: A) =>
    (fn: Unary<A, B>) =>
      fn(x)
  
  export const includes = (value: unknown) => (list: unknown[]) => list.includes(value)
  
  export function filter<T>(predicate: Unary<T, boolean>) {
    return function (list: T[]) {
      const result: T[] = []
      for (const item of list) {
        if (predicate(item)) {
          result.push(item)
        }
      }
      return result
    }
  }
  
  export function splitEvery(count: number) {
    return function <T>(list: T[]) {
      const result = []
      let idx = 0
      while (idx < list.length) {
        result.push(list.slice(idx, idx + count))
        idx += count
      }
      return result
    }
  }